module.exports = __webpack_public_path__ + "img/like.01663161.svg";